import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from "@angular/core";
import * as feather from "feather-icons";
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { NavService } from "src/app/shared/services/nav.service";
import { LayoutService } from "src/app/shared/services/layout/layout.service";
import { slider } from "../../../data/animation/route-animations";
import { RoleEnum } from "src/app/shared/models/user/role.interface";
import { JwtService } from "src/app/shared/services/jwt.service";
import { select, Store } from "@ngrx/store";
import { AppStateInterface } from "src/app/store/appState.interface";
import { dashboardSettingsSelector } from "src/app/store/user/user.selectors";
import { Observable, takeUntil } from "rxjs";
import { DashboardSettingsInterface } from "src/app/shared/models/dashboard-settings.interface";
import { BaseComponent } from "src/app/base.component";
import { getDashboardSettings } from "src/app/store/user/user.actions";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  animations: [slider],
})
export class DashboardComponent extends BaseComponent implements OnInit {
  @Output() icon = new EventEmitter<string>();
  footerDark: boolean;
  footerLight: boolean;
  footerFix: boolean;
  Scorlled: boolean;
  public show: boolean = true;
  public width = window.innerWidth;
  public screenwidth: any = window.innerWidth;
  dashBoardSettings$: Observable<DashboardSettingsInterface | null>;
  constructor(
    public navServices: NavService,
    public layout: LayoutService,
    public route: ActivatedRoute,
    private router: Router,
    private store: Store<AppStateInterface>,
    private jwtService: JwtService
  ) {
    super(store);
    this.dashBoardSettings$ = this.store
      .pipe(select(dashboardSettingsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    if (
      window.location.pathname == "/dashboard" &&
      localStorage.getItem("token") != null
    ) {
      this.handleNavigationByRole();
    }
  }

  handleNavigationByRole() {
    const role = this.jwtService.getRoleName(localStorage.getItem("token"));
    switch (role) {
      case RoleEnum.ROLE_ADMIN: {
        this.router.navigate(["dashboard/admin"], {replaceUrl: true});
        break;
      }
      case RoleEnum.ROLE_ADVERTISER: {
        this.router.navigate(["dashboard/advertiser"], {replaceUrl: true});
        break;
      }
      case RoleEnum.ROLE_LOCATION: {
        this.router.navigate(["dashboard/location-partner"], {replaceUrl: true});
        break;
      }
      case RoleEnum.ROLE_FRANCHISE: {
        this.router.navigate(["dashboard/franchise"], {replaceUrl: true});
        break;
      }
      default:
        this.router.navigate([""]);
    }
  }

  ngOnInit(): void {
    this.store.dispatch(getDashboardSettings());

    this.dashBoardSettings$.subscribe((data) => {
      if (data != null) this.layout.config = data;
    });
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.screenwidth = event.target.innerWidth;

    if (this.screenwidth < 991) {
      return (this.layout.config.settings.sidebar = "compact-wrapper");
    } else {
      let newLayout = this.layout.config.settings.sidebar;
      return (newLayout =
        this.layout.config.settings.sidebar || "horizontal-wrapper");
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
    });
  }

  public getRouterOutletState(outlet: any) {
    return outlet.isActivated ? outlet.activatedRoute : "";
  }
  ngDoCheck() {
    if (window.location.pathname == "/page-layout/footer-dark") {
      this.footerDark = true;
      this.footerLight = false;
      this.footerFix = false;
      this.Scorlled = false;
    } else if (window.location.pathname == "/page-layout/footer-light") {
      this.footerLight = true;
      this.footerDark = false;
      this.footerFix = false;
      this.Scorlled = false;
    } else if (window.location.pathname == "/page-layout/footer-fixed") {
      this.footerFix = true;
      this.footerLight = false;
      this.footerDark = false;
      this.Scorlled = false;
    } else if (window.location.pathname == "/page-layout/hide-nav-scroll") {
      this.Scorlled = true;
      this.footerFix = false;
      this.footerLight = false;
      this.footerDark = false;
    } else if (window.location.pathname == "/dashboard" &&
      localStorage.getItem("token") != null
    ) {
      this.handleNavigationByRole();
    }
  }

  @HostListener("window:scroll", [])
  scrollHandler() {
    let number =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (window.location.pathname == "/page-layout/hide-nav-scroll") {
      if (number > 600) {
        this.show = true;
      } else if (number === 0) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  }

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData["animation"]
    );
  }
}
